import graphql__3e8bda0c7456b06603ed from "./__generated__/ContributionsMapContributionTooltipContent_contribution.graphql.js";import { graphql, useFragment } from "react-relay";

import ReactableMeasures from "../ReactableMeasures";

const ContributionsMapContributionTooltipContent = props => {
  const contribution = useFragment(
    ContributionsMapContributionTooltipContent_contribution,
    props.contribution
  );
  const { title } = contribution;

  return (
    <>
      {title}

      <ReactableMeasures className="margin-top-xs" reactable={contribution} />
    </>
  );
};

const ContributionsMapContributionTooltipContent_contribution = graphql__3e8bda0c7456b06603ed;

export default ContributionsMapContributionTooltipContent;
